export default "__VITE_ASSET__DJlSCAhx__"